import { FC, useMemo } from 'react'
import { Participants } from 'src/app/types'
import HostParticipant from 'src/components/Participant/HostParticipant'
import Participant from 'src/components/Participant/Participant'

type SessionParticipantsProps = {
  participants: Participants
  isHost: boolean
}
const SessionParticipants: FC<SessionParticipantsProps> = ({
  participants,
  isHost,
}) => {
  const sortedParticipants = useMemo(
    () =>
      Object.values(participants).sort((a, b) =>
        a.screenName.localeCompare(b.screenName)
      ),
    [participants]
  )
  return (
    <>
      {sortedParticipants.map((participant) =>
        isHost ? (
          <HostParticipant {...participant} key={participant.screenName} />
        ) : (
          <Participant {...participant} key={participant.screenName} />
        )
      )}
    </>
  )
}

export default SessionParticipants
